import Slider from 'swiper';

import './slider.css';

export default Slider;
